import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { Spinner } from '@tcc/crate';
import { has } from 'lodash';

// selectors
import { getFatalError } from 'current/selectors';
import { getAllMessages } from 'messages/selectors';
import { isFullPayloadInitialLoadDone } from 'api/loading/selectors';

// components
import FatalError from 'common/FatalError';
import MessagePanel from 'messages/MessagePanel';

let LoadingWrapperContainer = ({
  error,
  initialLoadIsInProgress,
  messages,
  children
}) => {
  if (error) {
    return ( // A fatal error occurred, show a message
      <FatalError error={error} />
    );
  }
  if (initialLoadIsInProgress) {
    // At least one module is still not loaded, show spinner
    return (
      <div className='vra-loading-wrapper__spinner'>
        <Spinner size={24} />
        <MessagePanel
          closeMessage={() => { }}
          isToolbarShown={false}
          messages={messages}
        />
      </div>
    );
  }

  // If everything is loaded without fatal errors, show the real thing
  return (
    <div className='vra-content' data-test-id='script-creator-content'>{children}</div>
  );
};

LoadingWrapperContainer.propTypes = {
  children: propTypes.node.isRequired,
  error: propTypes.object,
  initialLoadIsInProgress: propTypes.bool.isRequired,
  messages: propTypes.array.isRequired
};

LoadingWrapperContainer = connect(
  // mapStateToProps
  (state, ownProps) => {
    const initialLoadIsInProgress = has(ownProps, 'initialLoadIsInProgress')
      ? ownProps.initialLoadIsInProgress
      : !isFullPayloadInitialLoadDone(state);
    return {
      error: getFatalError(state),
      initialLoadIsInProgress,
      messages: getAllMessages(state)
    };
  }
)(LoadingWrapperContainer);

export default LoadingWrapperContainer;
